import { useTranslation } from 'react-i18next';
import { ArrowPathIcon } from '@heroicons/react/24/solid';
import { motion } from 'motion/react';

interface CollabHeaderProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  onRefresh: () => void;
  isLoading: boolean;
}

export const CollabHeader: React.FC<CollabHeaderProps> = ({
  searchTerm,
  onSearchChange,
  onRefresh,
  isLoading,
}) => {
  const [t] = useTranslation('locale');

  return (
    <motion.div
      className="border-base-200 bg-base-100 flex flex-col gap-4 border-b px-6 py-4"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-center justify-between">
        <motion.h1
          className="text-base-content text-2xl font-bold"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          {t('collab.title', 'Collaboration Hub')}
        </motion.h1>

        <motion.button
          className="btn btn-ghost btn-circle"
          onClick={onRefresh}
          disabled={isLoading}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
        >
          <ArrowPathIcon
            className={`h-5 w-5 ${isLoading ? 'animate-spin' : ''}`}
          />
        </motion.button>
      </div>

      <motion.div
        className="relative"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        {/* <label className="input bg-base-200 flex w-full items-center rounded-full">
          <input
            type="text"
            className="grow bg-transparent text-sm"
            placeholder={t(
              'collab.search_placeholder',
              'Search conversations...',
            )}
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <MagnifyingGlassIcon className="text-base-content/60 h-5 w-5" />
        </label> */}
      </motion.div>
    </motion.div>
  );
};
